import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/patient";
const API_PATH_ADSM =ConstantList.API_ENPOINT + "/api/adsm-patient";

export const pagingPatients = (searchObject) => {
  var url = API_PATH + "/getPage";
  return axios.post(url, searchObject);
};

export const patientManagement = (searchObject) => {
  var url = API_PATH + "/patientManagement";
  return axios.post(url, searchObject);
};

export const getPatient = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const getSummaryPatient = (id) => {
  let url = API_PATH + "/summaryPatient/" + id;
  return axios.get(url);
};

export const createPatient = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editPatient = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deletePatient = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};

export const sumPatient = (obj) => {
  let url = API_PATH + "/sumPatient";
  return axios.post(url, obj);
};

export const checkExist = (obj) => {
  let url = API_PATH + "/checkExist";
  return axios.post(url, obj);
};

export const getTotal = (obj) => {
  let url = API_PATH + "/getTotal";
  return axios.post(url, obj);
};

export const etbPatientManager = (obj) => {
  let url = API_PATH + "/etb-patient-manager";
  return axios.post(url, obj);
};

export const getPageEtbPatientManager = (obj) => {
  let url = API_PATH + "/get-page-etb-patient-manager";
  return axios.post(url, obj);
}

export const getEtb = (id) => {
  let url = API_PATH + "/get-etb/" + id;
  return axios.get(url);
}

export const createEtbPatient = (obj) => {
  let url = API_PATH + "/save-etb-patient";
  return axios.post(url, obj);
}

export const editEtbPatient = (obj) => {
  let url = API_PATH + "/save-etb-patient/" + obj.id;
  return axios.put(url, obj);
};

export const getListHistoryEncounter = (id) => {
  let url = API_PATH + "/get-list-history-encounter/" + id;
  return axios.get(url);
}

export const getEtbAll = (obj) => {
  let url = API_PATH + "/get-etb-all";
  return axios.post(url, obj);
}

export const createEtbPatientEncounter = (obj) => {
  let url = API_PATH + "/save-etb-patient-encounter";
  return axios.post(url, obj);
}

export const checkDuplicationPatient = (obj) => {
  let url = API_PATH + "/check-duplication-patient";
  return axios.post(url, obj);
}

export const pendingTestList = (obj) => {
  let url = API_PATH + "/pending-test-list";
  return axios.post(url, obj);
};

export const examinateList = (obj) => {
  let url = API_PATH + "/etb-patient-manager/get-list-examine-request";
  return axios.post(url, obj);
};

export const checkADSMPatient = (obj) => {
  let url = API_PATH + "/check-adsm-patient/" + obj.patientId;
  return axios.post(url, obj);
};

export const saveADSMPatient = (obj) => {
  let url = API_PATH_ADSM + `/${obj.id}`  ;
  return axios.put(url, obj);
};

export const getPatientOrganization = (obj) => {
  let url = API_PATH + "/get-patient-organization";
  return axios.post(url, obj);
};

export const getPatientDelayedAppointment = (obj) => {
  let url = API_PATH + "/patient-delayed-appointment";
  return axios.post(url, obj);
};

export const additionalAdsmPatient = (obj) => {
  let url = API_PATH + `/additional-adsm-patient/${obj.patientId}/${obj.periodId}`;
  return axios.get(url);
}

export const doNotTestRForLpa = (obj) => {
  let url = API_PATH + "/do-not-test-r-for-lpa";
  return axios.post(url, obj);
};

export const resistanceResultsWithoutRegimenEAndIndividual = (obj) => {
  let url = API_PATH + "/resistance-results-without-regimen-e-and-individual";
  return axios.post(url, obj);
};

export const countStatusPatient = (obj) => {
  let url = API_PATH + "/etb-patient-manager/count-status-patient";
  return axios.post(url, obj);
}

export const countByAdministrativeUnit = (obj) => {
  let url = API_PATH + "/etb-patient-manager/count-by-administrative-unit";
  return axios.post(url, obj);
}

export const getPagePatient = (obj) => {
  let url = API_PATH + "/etb-patient-manager/get-page-patient";
  return axios.post(url, obj);
}
export const getPagePatientManagementUnit = (obj) => {
  let url = API_PATH + "/etb-patient-manager/list-of-patients-by-management-unit";
  return axios.post(url, obj);
}

export const getPagePatientMoveInOrOut = (obj) => {
  let url = API_PATH + "/etb-patient-manager/get-page-patient-move-in-or-out";
  return axios.post(url, obj);
}

export const exportCurrentPatientList = (obj) => {
  let url = ConstantList.API_ENPOINT + "/api/etb/download-file/export-current-patient-list";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
}
export const exportPatientIndexList = (obj) => {
  let url = ConstantList.API_ENPOINT + "/api/etb/download-file/export-list-patient-index";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
}

export const pagingNotificationPatients = (obj) => {
  let url = ConstantList.API_ENPOINT + "/api/notificationpatient/paging-notification-patients";
  return axios.post(url, obj);
}

export const saveClinicalServiceRequestByEncounter = (obj, idEncounter) => {
  let url = ConstantList.API_ENPOINT + "/api/etb/list-tests-waiting-for-results/save-clinical-service-request-by-encounter/" + idEncounter;
  return axios.post(url, obj);
}

export const saveEtbServiceItemObsHiv = (obj, idEncounter) => {
  let url = ConstantList.API_ENPOINT + "/api/etb/list-tests-waiting-for-results/save-etb-service-item-obs-hiv/" + idEncounter;
  return axios.post(url, obj);
}

export const incompletePatientAdsm = (patientId) => {
  let url = API_PATH_ADSM + "/incomplete-patient-adsm/" + patientId;
  return axios.get(url);
}

export const exportManagementUnitList = (obj) => {
  let url = ConstantList.API_ENPOINT + "/api/etb/download-file/export-patient-management-unit";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
}

export const getEtbPatientOverview = (patientId, periodId) => {
  let url = `${API_PATH}/get-etb-patient-overview/${patientId}/${periodId}`
  return axios.get(url);
}

export const getPatientDetails = (patientId, periodId) => {
  let url;
  if (periodId) {
    url = `${API_PATH}/get-patient-details/${patientId}/${periodId}`
  } else {
    url = `${API_PATH}/get-patient-details/${patientId}`
  }
  return axios.get(url);
}

export const pagingNotificationPatientsByNotification = (obj) => {
  let url = ConstantList.API_ENPOINT + "/api/notificationpatient/paging-notification-patients-by-notification";
  return axios.post(url, obj);
}

export const saveListNotificationPatients = (patientId, list) => {
  let url = ConstantList.API_ENPOINT + "/api/notificationpatient/save-list-notification-patients/" + patientId;
  return axios.post(url, list);
}

export const getRolePatient = (id) => {
  let url = API_PATH + "/get-role-patient/" + id;
  return axios.get(url);
};

export const acceptPatientFromOther = dto => {
  const url = API_PATH + "/accept-patient-from-other"
  return axios.post(url, dto)
}

export const notAcceptPatientFromOther = dto => {
  const url = API_PATH + "/not-accept-patient-from-other"
  return axios.post(url, dto)
}